if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.storageKey = 'tt_recently_viewed_products';
      this.limit = parseInt(this.dataset.limit, 10) || 4;
      this.currentHandle = this.dataset.currentHandle || '';
      this.grid = this.querySelector('[data-recently-viewed-grid]');

      this.load();
    }

    getHandles() {
      var handles = [];
      try {
        handles = JSON.parse(window.localStorage.getItem(this.storageKey)) || [];
      } catch (e) {
        handles = [];
      }
      if (!Array.isArray(handles)) {
        handles = [];
      }
      var currentHandle = this.currentHandle;
      if (currentHandle) {
        handles = handles.filter(function (handle) {
          return handle !== currentHandle;
        });
      }
      return handles.slice(0, this.limit);
    }

    async load() {
      var handles = this.getHandles();

      if (!this.grid || handles.length === 0) {
        this.hidden = true;
        return;
      }

      var results = await Promise.all(
        handles.map((handle) => this.fetchCard(handle))
      );

      var fragment = document.createDocumentFragment();
      results.forEach((markup) => {
        if (!markup) return;
        var li = document.createElement('li');
        li.className = 'grid__item';
        li.innerHTML = markup;
        fragment.appendChild(li);
      });

      if (!fragment.childElementCount) {
        this.hidden = true;
        return;
      }

      this.grid.appendChild(fragment);
      this.hidden = false;
    }

    async fetchCard(handle) {
      try {
        var response = await fetch(
          '/products/' + encodeURIComponent(handle) + '?section_id=recently-viewed-product-card'
        );
        if (!response.ok) return null;
        var text = await response.text();
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var card = doc.querySelector('.card-wrapper');
        return card ? card.outerHTML : null;
      } catch (e) {
        return null;
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
